import { useAuthBootstrap } from "@/services";

/**
 * Hech narsa chizmaydi: `/auth/me` ni bir marta o'qib, foydalanuvchini
 * do'konga yozadi. Alohida komponent — hook'ni `App` ichida chaqirsak,
 * har bir qayta chizishda butun daraxt uning holatiga bog'lanib qolardi.
 */
export const AuthBootstrap = () => {
  useAuthBootstrap();
  return null;
};
